import { useState } from "react";
import { Link, useLoaderData } from "react-router";

import {
  DropdownMenuArrow,
  DropdownMenuSubTrigger,
} from "@radix-ui/react-dropdown-menu";
import { DotsVerticalIcon, GlobeIcon, HeartIcon } from "@radix-ui/react-icons";

import type { loader } from "~/routes/layout";

import { CoutrySelector } from "../country-selector";
import { Button } from "../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { LocationIcon } from "../ui/location-icon";

const MeganavSubmenu: React.FC = () => {
  const { isLoggedIn } = useLoaderData<typeof loader>();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Button className="m-0 border-none bg-transparent p-0 text-inherit hover:bg-transparent focus-visible:outline-none active:bg-transparent sm-max:hidden">
          <DotsVerticalIcon className="p-0" />
        </Button>
      </DropdownMenuTrigger>

      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 z-10 bg-black bg-opacity-20"
          onClick={() => setIsOpen(false)}
          role="button"
          tabIndex={0}
          onKeyDown={e => {
            if (e.key === "Escape" || e.key === " ") {
              e.preventDefault();
              e.currentTarget.click();
            }
          }}
        ></div>
      )}

      {/* Dropdown Menu */}
      <DropdownMenuPortal>
        <DropdownMenuContent
          side="bottom"
          align="center"
          className="mr-2 w-44"
          loop
          hideWhenDetached={true}
        >
          <DropdownMenuArrow className="center fixed right-[-2px] top-[-2px] mb-0 h-0 w-0 !border-b-0 border-l-8 border-r-8 border-t-8 border-transparent border-t-white"></DropdownMenuArrow>

          <DropdownMenuItem onClick={() => setIsOpen(false)}>
            <HeartIcon />
            <Link
              to={isLoggedIn ? "/account/wishlist" : "/wishlist"}
              className="ml-1"
            >
              Wishlist
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setIsOpen(false)}>
            <Link to={"/store-locator"}>
              <LocationIcon />
              <span className="ml-1">Store Finder</span>
            </Link>
          </DropdownMenuItem>
          <DropdownMenuSub>
            <div className="flex flex-row content-center px-[9px] py-1.5">
              <span className="self-center">
                <GlobeIcon />
              </span>
              <span className="ml-[5px] self-center text-sm">Language</span>
              <div className="block self-center px-2 text-sm text-gray-700 hover:bg-gray-100 hover:no-underline">
                <DropdownMenuSubTrigger asChild>
                  <CoutrySelector />
                </DropdownMenuSubTrigger>
              </div>
            </div>
          </DropdownMenuSub>
        </DropdownMenuContent>
      </DropdownMenuPortal>
    </DropdownMenu>
  );
};

export default MeganavSubmenu;
